import { Box, Button, Flex, Image, Text, useBoolean } from '@chakra-ui/react';
import bgAutoBrandModelImage from 'assets/background/auto_brand.png';
import { ReactComponent as MagicPenIcon } from 'assets/icons/magic_pen.svg';
import { AUTO_BRAND_OPENED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { AutoBrand, AutoBrandCard } from 'modules/Editor/components/AutoBrand';
import { useTranslation } from 'react-i18next';

interface AutoBrandViewProps {
  buttonLabel: string;
  hasBrandEditPermission: boolean;
  mixpanelFrom: string;

  // TODO remove this when brand kit experiment is done
  type?: 'card' | 'view';
}

export const AutoBrandView = ({
  buttonLabel,
  hasBrandEditPermission,
  mixpanelFrom,
  type = 'view',
}: AutoBrandViewProps) => {
  const [showAutoBrand, toggleAutoBrand] = useBoolean(false);
  const { t } = useTranslation('auto_brand', { useSuspense: false, keyPrefix: 'modals.autoBrand' });

  /**
   * It handles MP events and open the auto brand modal
   */
  const openAutoBrand = () => {
    Mixpanel.track(AUTO_BRAND_OPENED.eventName, {
      from: mixpanelFrom,
    });
    toggleAutoBrand.on();
  };

  if (type === 'card') {
    return (
      <Box mt={2}>
        <AutoBrandCard type='card' mixpanelFrom={mixpanelFrom} />
      </Box>
    );
  }

  return (
    <Flex
      direction='column'
      alignItems='center'
      justifyContent='center'
      padding={4}
      data-testid='brand-auto-brand-view'
      borderRadius={6}
      border='1px solid'
      borderColor='gray.100'
      textAlign='center'
    >
      <AutoBrand isOpen={showAutoBrand} onClose={toggleAutoBrand.off} />
      <Image src={bgAutoBrandModelImage} w='7.5rem' role='presentation' />
      <Text fontSize='md' fontWeight='semibold' marginTop={4}>
        {t('lookProfessional')}
      </Text>
      <Text fontSize='xs' p='2' marginTop={2} textAlign='center'>
        {t('createAVisual')}
      </Text>
      {hasBrandEditPermission && (
        <Button
          onClick={openAutoBrand}
          leftIcon={<MagicPenIcon fill='var(--vg-colors-white)' />}
          size='sm'
          w='100%'
          variant='purple'
          marginTop={4}
          data-testid='brand-open-auto-brand-modal'
        >
          {buttonLabel}
        </Button>
      )}
      {!hasBrandEditPermission && (
        <Text fontSize='sm' fontWeight='semibold' textAlign='center' marginTop={4}>
          {t('askYourAdmin')}
        </Text>
      )}
    </Flex>
  );
};
